// extracted by mini-css-extract-plugin
module.exports = {"section":"banner-module--section--kbp3z","sectionGrey":"banner-module--section-grey--wtwub","container":"banner-module--container--1JIAP"};